module.exports = __webpack_public_path__ + "acd7b247dfb881a8bab027a9ddcabed8.svg";